import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import {
  BsPreparationSection,
  BsResultsSection,
  BsTestFractionParticleDensitySection,
} from 'Components/Worksheets/MaximumDryDensityWorksheet/Bs/Shared/Sections';
import { GradningZoneType } from 'Components/Worksheets/MaximumDryDensityWorksheet/types';
import ids from 'Components/Worksheets/QestIds';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import BsCompactionSection from './CompactionSection/CompactionSection';

const qestIds = [ids.maximumDryDensity.BS_1377_2_Clause_11_7.rev2022];

const Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const gradingZoneEqualsX = useSelector(
    pipe(createWorksheetSelector!('Preparation.GradingZone'), (t) => t === GradningZoneType.X)
  );

  const completeTestByAgreementWithClient = useSelector(
    pipe(createWorksheetSelector!('Preparation.CompleteTestByAgreementWithClient'), valueOrDefault(false))
  );

  return (
    <>
      <PageSection heading="Preparation">
        <BsPreparationSection />
      </PageSection>

      {(!gradingZoneEqualsX || completeTestByAgreementWithClient) && (
        <>
          <PageSection heading="Compaction">
            <BsCompactionSection />
          </PageSection>
          <PageSection heading="Test Fraction Particle Density">
            <BsTestFractionParticleDensitySection />
          </PageSection>
        </>
      )}
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <BsResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

Worksheet.qestIds = qestIds;
const Bs11_7_MaximumDryDensityWorksheet = withInjectedProps(Worksheet);

export { Bs11_7_MaximumDryDensityWorksheet };
export default Bs11_7_MaximumDryDensityWorksheet;
